<div class="filter-sort-container">
  <div class="filter-block flex flex-row flex-wrap gap-x-4">
    <app-filter-by-project
      [projectFilter]="projectFilter"
      (filterByProjectCallbackFunction)="projectChangeCallbackFunction($event)" />

    <app-pagination-filter-page-size
      [pageSizes] = "[10,25,50,100]"
      [selectedPageSize]="pageSize"
      (callbackFunction)="paginationPageSizeCallbackFunction($event)" />
  </div>

  <div class="action-block flex flex-nowrap mt-1.5">
    <!-- actions for multiple experiments -->
    <div
      class="mt-1 mr-1 min-w-48">
      @if (selectedThingies().length > 0 && isEditor() === true) {
        <app-task-status-bar
          [showCalculationSpinner]="forceToShowCalculationSpinner()"
          [taskKey]="{thingies: selectedThingies()}"
          viewMode="menuItemGroup"
        ></app-task-status-bar>
      } @else {
        <button
          [matTooltip]="!isEditor() ? 'You need to have editor permissions in the projects of selected objects to apply actions.' : 'Select experiments to apply actions.'"
          mat-flat-button
          class="w-full xs"
          color="primary"
          [disabled]="true"
          >
          <span class="flex justify-between w-full">
            No actions
            <ion-icon class="h-[20px]" name="chevron-down-outline"></ion-icon>
          </span>
        </button>
      }
    </div>

    <div>
      <button
        [matTooltip]="selectedThingies().length === 0 ? 'Select experiments to apply actions.' : ''"
        [disabled]="selectedThingies().length === 0"
        mat-icon-button
        [matMenuTriggerFor]="thingiesActionsMenu"
      >
        <ion-icon name="menu-outline" />
      </button>

      <mat-menu #thingiesActionsMenu>

        <!-- Edit experiment -->
        <button
          [disabled]="!onlyOneExperimentIsSelected || !isEditor() || archive"
          mat-menu-item
          (click)="$event.preventDefault(); _editExperiment(selectedThingies()[0])"
          [matTooltip]="!isEditor() ? 'You need to have editor permissions in the projects of selected objects to edit.' : 'Edit experiment'"
          >
          <ion-icon class="menu-icon" name="pencil-outline" />
          Edit
        </button>

        
        @if(archivableSelections) {
          @if (!archive) {
            <button
              [matTooltip]="!isEditor() ? 'You need to have editor permissions in the projects of selected replicates to archive.' : 'Archive selected replicates'"
              [disabled]="archiveActionInProgress || !isEditor()"
              (click)="archiveThingies()"
              mat-menu-item
            >
              <ion-icon name="archive-outline" />Archive
            </button>
          } @else {
            <button
              [matTooltip]="!isEditor() ? 'You need to have editor permissions in the projects of selected replicates to restore.' : 'Restore selected replicates'"
              [disabled]="archiveActionInProgress || !isEditor()"
              (click)="restoreThingies()"
              mat-menu-item
            >
              <ion-icon src="assets/svg/unarchive.svg" />Restore
            </button>
          }
        }

        @if (archive === false && archivableSelections === false) {
          <button
            [disabled]="true"
            mat-menu-item
            matTooltip="Experiment replicates must not have running tasks to archive."
            >
            Archive
          </button>
        }

        <mat-divider class="![--mat-divider-width:3px]" />


        <!-- Duplicate >>REPLICATE<< -->
        @let replicateDuplicateTooltip = !isEditor()
          ? 'You need to have editor permissions in the projects of selected replicates to duplicate this replicate.'
          : (selectedThingies().length === 0 || selectedThingies().length > 1)
            ? 'Select exactly one replicate to use this function.'
            : 'Duplicate replicate.';
        <button
          [disabled]="!onlyOneExperimentIsSelected || selectedThingies().length === 0 || selectedThingies().length > 1 || !isEditor()"
          mat-menu-item
          (click)="$event.preventDefault(); _duplicateReplicate(selectedThingies()[0])"
          [matTooltip]="replicateDuplicateTooltip"
        >
          <ion-icon src="/assets/custom-icons/copy-r-outline.svg" />
          Duplicate Replicate
        </button>

        <!-- Duplicate >>EXPERIMENT<< -->
        <button
          [disabled]="!onlyOneExperimentIsSelected || !isEditor()"
          mat-menu-item
          (click)="$event.preventDefault(); _duplicateExperiment(selectedThingies()[0])"
          [matTooltip]="
            !isEditor() 
            ? 'You need to have editor permissions in the projects of selected objects to duplicate this experiment.' 
            : 'Duplicate experiment.'"
        >
          <ion-icon src="/assets/custom-icons/copy-e-outline.svg" />
          Duplicate Experiment
        </button>

        <mat-divider class="![--mat-divider-width:3px]" />


        <!-- Add annotation-->
        <button
          [disabled]="!onlyOneExperimentIsSelected || !isEditor() || archive"
          mat-menu-item
          (click)="_addAnnotation()"
          [matTooltip]="!isEditor() ? 'You need to have editor rights in the projects of selected objects to add annotation.' : 'Add annotation'"
        >
          <ion-icon src="/assets/svg/add-annotation-outline.svg" />
          Add Annotation
        </button>

        <button
          (click)="downloadThingies()"
          mat-menu-item
          matTooltip="Export data/selected replicates"
        >
          <ion-icon name="download-outline" />
          Export
        </button>
      </mat-menu>
    </div>

    <button
      mat-icon-button
      class="!overflow-hidden"
      (click)="toggleAllGroupCollapsing()"
    >
      <img
        src="/assets/svg/double-chevron-up.svg"
        class="animate-transform"
        [class.turn-180]="allGroupsCollapseState === 'collapsed'"
        [matTooltip]="allGroupsCollapseState === 'collapsed' ? 'Expand all' : 'Collapse all'"
        />
    </button>
  </div>
</div>

<table
  mat-table
  [dataSource]="tableDataSource"
  matSort
  (matSortChange)="onSortChange($event)"
  [multiTemplateDataRows]="true"
  class="thingie-table manual-stripes"
>
  <!---- Checkbox state/s ---->
  <ng-container matColumnDef="status">
    <th mat-header-cell *matHeaderCellDef class="!text-center !align-middle !pl-4 !pr-0 !py-4">
      <mat-checkbox
        (change)="selectAllThingies($event.checked)"
        [checked]="getAllThingiesCheckedState() === 'all'"
        [indeterminate]="getAllThingiesCheckedState() === 'some'"
      ></mat-checkbox>
    </th>
    <td mat-cell *matCellDef="let thingieGroup" class="!text-center !pl-4 !pr-0 !py-4">
      @for (displayThingie of thingieGroup.thingies; track trackDisplayThingieById(i, displayThingie); let i = $index) {
        <!-- show for all thingies without group -->
        @if (thingieGroup.thingies.length === 1) {
          <mat-checkbox
            [checked]="getThingieCheckedState(displayThingie)"
            (change)="selectThingie(thingieGroup, displayThingie, $event.checked)"
          ></mat-checkbox>
        }
        <!-- show for thingie group parent -->
        @if(i === 1) {
          <mat-checkbox
            [checked]="getGroupCheckedState(thingieGroup) === 'all'"
            [indeterminate]="getGroupCheckedState(thingieGroup) === 'some'"
            (change)="setGroupSelectionState(thingieGroup, $event.checked)"
          ></mat-checkbox>
        }
      }
    </td>
  </ng-container>

  <ng-container matColumnDef="status_detail">
    <td mat-cell *matCellDef="let thingieGroup;" class="!text-center !pt-2 !pl-4 !pr-0 !py-4 !overflow-visible">
      <div class="relative left-6 flex flex-col gap-1">
        @for (displayThingie of thingieGroup.thingies; track trackDisplayThingieById(i, displayThingie); let i = $index) {
          <mat-checkbox
            [checked]="getThingieCheckedState(displayThingie)"
            (change)="selectThingie(thingieGroup, displayThingie, $event.checked)"
          ></mat-checkbox>
          @if (i !== thingieGroup.thingies.length - 1) {
            <div class="separator"></div>
          }
        }
      </div>
    </td>
  </ng-container>

  <!---- Object/Thingie Name ---->

  <ng-container matColumnDef="thingieName">
    <th mat-header-cell *matHeaderCellDef app-coco-sort-header class="header">
      <div class="w-full flex items-center flex-nowrap justify-between">
        <span class="header-label">Name</span>
        <small>(Replicate count)</small>
      </div>
      <div class="thingie-filter-container">
        <mat-form-field class="compact small">
          <mat-icon class="search-icon" matPrefix>search</mat-icon>
          <input
            placeholder="Type to search"
            matInput
            [formControl]="thingieNameFilter"
            type="search"
            (keydown)="$event.stopPropagation()"
            (click)="$event.stopPropagation()"
            />
        </mat-form-field>
      </div>
    </th>

    <td mat-cell *matCellDef="let thingieGroup;" class="truncate">
      <div class="flex flex-nowrap items-center">

        <!-- show expand/collapse icon -->
        @if (thingieGroup.showGroupDetailToggle) {
          <span class="cursor-pointer"
            (click)="showGroupDetails(thingieGroup, false)">
            <ion-icon class="expandable-icon" name="caret-down-outline"></ion-icon>
          </span>
        } @else {
          <span class="cursor-pointer"
            (click)="showGroupDetails(thingieGroup, true)">
            <ion-icon class="expandable-icon" name="caret-forward-outline"></ion-icon>
          </span>
        }
        
        <!-- show group name -->
        <a
          [matTooltip]="thingieGroup.name"
          class="stack-thingie-name"
          (click)="openExperimentGroupDialog(thingieGroup)"
        >
          <app-string-ellipsis
            [cssClass]="'!h-unset mt-0'"
            [input]="thingieGroup.name"
            [highlightMatchedPart]="thingieNameFilter.value" />
        </a>


        <!-- display number of replicates in experiment -->    
        <span class="justify-self-end">
          <span>
            ({{ thingieGroup.thingies.length }})
          </span>
        </span>
      </div>
    </td>
  </ng-container>

  <!---- State badge ---->

  <ng-container matColumnDef="thingieStatus">
    <th mat-header-cell *matHeaderCellDef app-coco-sort-header class="centered">
      <span class="header-label">Status</span>
    </th>
    <td mat-cell *matCellDef="let thingie">
      <div class="flex justify-center">
        @if ((thingie.thingies | pureFnCall:getThingiesByIds | async); as thingies) {
          <app-thingie-state-chip
            [thingies]="thingies"
          ></app-thingie-state-chip>
        }
      </div>
    </td>
  </ng-container>

  <ng-container matColumnDef="thingieStatus_detail">
    <td mat-cell *matCellDef="let thingieGroup;" class="!pt-2">
      <div class="flex flex-col gap-y-1">
        @if ((thingieGroup.thingies | pureFnCall:getThingiesByIds | async); as thingies) {
          @for (thingie of thingies; track thingie; let i = $index) {
            @if(thingie !== undefined) {
              <app-thingie-state-chip [thingie]="thingie"></app-thingie-state-chip>
              @if (i !== thingieGroup.thingies.length - 1) {
                <div class="separator"></div>
              }
            }
          }
        }
      </div>
    </td>
  </ng-container>

  <ng-container matColumnDef="thingieName_detail">
    <td mat-cell *matCellDef="let thingieGroup;" class="truncate !pt-2">
      <div class="flex flex-col gap-1 pl-5">
        @for (thingieItem of thingieGroup.thingies; track thingieItem; let i = $index) {
          <span>
            <a
              [routerLink]="[urls.route.thingieDetail(thingieItem.thingieId)]"
              [matTooltip]="thingieItem.thingie.name"
              class="thingie-name p-0"
              >
              <app-string-ellipsis
                [cssClass]="'!h-unset mt-0'"
                [input]="thingieItem.thingie.name" 
                [highlightMatchedPart]="thingieNameFilter.value" />
            </a>
          </span>
          @if (i !== thingieGroup.thingies.length - 1) {
            <div class="separator"></div>
          }
        }
      </div>
    </td>
  </ng-container>

  <!---- Assigned Devices ---->

  <ng-container matColumnDef="assignedDevices">
    <th mat-header-cell *matHeaderCellDef app-coco-sort-header #assignedDevicesHeader>
      <span class="header-label">Assigned Devices</span>
      <div class="thingie-filter-container">
        <mat-form-field class="compact small">
          <mat-icon class="search-icon" matPrefix>search</mat-icon>
          <input
            placeholder="Type to search"
            matInput
            [formControl]="deviceFilter"
            (keydown)="$event.stopPropagation()"
            (click)="$event.stopPropagation()"
            />
        </mat-form-field>
      </div>
    </th>

    <td mat-cell *matCellDef="let thingieGroup">
      <div class="overflow-container text-center">
        <div
            class="
              inline-block
              h-5 px-2
              rounded
              text-[12px] leading-5 font-semibold whitespace-nowrap
              bg-orange-90 text-orange-40
            "
          >
            @if(thingieGroup.devicesInGroup.length === 0) {
              No devices
            } @else {
              {{thingieGroup.deviceBadgeString}}
            }
          </div>
      </div>
    </td>
  </ng-container>

  <ng-container matColumnDef="assignedDevices_detail">
    <td mat-cell *matCellDef="let thingieGroup;" class="!pt-2">
      <div class="flex flex-col gap-1">
        @for(thingieItem of thingieGroup.thingies; track thingieItem.thingieId; let i = $index) {
          <div class="overflow-container">
            @if(thingieItem.assignedDevices.length === 0) {
              <span>
                No devices assigned
              </span>
            } @else {
              @for(entry of thingieGroup.extraThingieInfo[i]; track $index) {
                @if (entry.type === 'device') {
                  <span [matTooltip]="entry.device.tooltip">
                    <a [routerLink]="[urls.route.deviceDetail(entry.device.id)]">
                      <span [innerHtml]="entry.device.name | boldMatchedPart:deviceFilter.value ?? ''"></span>
                    </a>
                    @if($index !== thingieGroup.extraThingieInfo[i].length - 1) {
                      <span>, </span>
                    }
                  </span>
                } @else {
                  <a href="#displayAdditionalDevices"
                    (click)="$event.preventDefault(); showAssignedDevices(thingieItem)"
                    matTooltip="Click to view all assigned devices"
                    [class.font-bold]="entry.hasDeviceWithMatchingPart"
                  >
                    @if(entry.devices.length === 1) {
                      +1 device
                    } @else {
                      +{{ entry.devices.length }} devices
                    }
                  </a>
                }
              }
            }

            <br/>
          </div>

          @if(i !== thingieGroup.thingies.length - 1) {
            <div class="separator"></div>
          }
        }
      </div>
    </td>
  </ng-container>

    <!---- Creation Date ---->

    <ng-container matColumnDef="dateCreated">
      <th mat-header-cell *matHeaderCellDef app-coco-sort-header>
        <span class="header-label date-created-header">Date&nbsp;created</span>
        <div class="thingie-filter-container date-container">
          <mat-form-field class="compact small">
            <input
              placeholder="dd/mm/yyyy"
              (dateChange)="datePickerChange($event)"
              matInput
              [matDatepicker]="picker"
              (keydown)="$event.stopPropagation()"
              (click)="$event.stopPropagation()"
              />
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
          </mat-form-field>
        </div>
      </th>
      <td mat-cell *matCellDef="let thingie">
        @if(!thingie.showGroupDetailToggle) {
          <!-- since date is common, just show one when collapsed -->
          {{ thingie.thingies[0].dateCreated | date: 'dd/MM/yyyy' }}
        }
        <!-- @else() {
        show nothing when detail is opened
        } -->
      </td>
    </ng-container>

    <ng-container matColumnDef="dateCreated_detail">
      <td mat-cell *matCellDef="let thingieGroup;" class="!pt-2">
        <div class="flex flex-col gap-1">
          @for (object of thingieGroup.thingies; track object; let i = $index) {
            {{ object.dateCreated | date: 'dd/MM/yyyy' }}
            @if (i !== thingieGroup.thingies.length - 1) {
              <div class="separator"></div>
            }
          }
        </div>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
    <tr mat-row [class.!bg-blue-97]="i % 2" *matRowDef="let row; columns: displayedColumns; let i = dataIndex"></tr>
    <tr mat-row [class.!bg-blue-97]="i % 2" *matRowDef="let row; columns: displayedDetailColumns; let i = dataIndex;when: isExpanded"></tr>

    <!-- Row shown when there is no matching data. -->
    <!-- Blatant thievery from https://material.angular.io/components/table/examples#table-filtering -->
    <tr class="mat-row" *matNoDataRow>
      <td class="mat-cell" colspan="6">No data matching your criteria</td>
    </tr>
</table>
